import { initialOf } from "../../lib/format";

interface AvatarProps {
	name?: string | null;
	src?: string | null;
	frameSrc?: string | null;
	size?: number;
	className?: string;
}

/** A round avatar: image when available, otherwise a gradient initial. */
export function Avatar({ name, src, frameSrc, size = 40, className = "" }: AvatarProps) {
	const style = { width: size, height: size, fontSize: Math.round(size * 0.42) };
	if (frameSrc) {
		return (
			<span style={{ width: size, height: size }} className={`relative shrink-0 ${className}`}>
				<Avatar name={name} src={src} size={size} />
				<img
					src={frameSrc}
					alt=""
					className="pointer-events-none absolute left-1/2 top-1/2 max-w-none -translate-x-1/2 -translate-y-1/2"
					style={{ width: size * 1.32, height: size * 1.32 }}
				/>
			</span>
		);
	}
	if (src) {
		return (
			<img
				src={src}
				alt=""
				style={style}
				className={`shrink-0 rounded-full object-cover ${className}`}
			/>
		);
	}
	return (
		<span
			style={style}
			className={`brand-gradient grid shrink-0 place-items-center rounded-full font-bold text-white ${className}`}
		>
			{initialOf(name)}
		</span>
	);
}
